import "./index.scss";

interface IProps {
  color: string;
  onClickHandle?: () => void;
}

export const PencilIcon = ({ color, onClickHandle }: IProps) => {
  return (
    <div className="pencil-icon-wrapper" onClick={onClickHandle}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1732 0.0347223C11.8701 0.118027 11.7949 0.177404 11.0274 0.938464L10.2942 1.66561L12.3079 3.67867L14.3216 5.69175L15.0234 4.99106C15.4093 4.6057 15.7596 4.23706 15.8017 4.17184C16.0489 3.78921 16.0666 3.24114 15.8455 2.81498C15.7781 2.68512 15.5647 2.45939 14.5527 1.44739C13.2529 0.147639 13.2268 0.125571 12.8808 0.0354614C12.7005 -0.0115045 12.3427 -0.0118867 12.1732 0.0347223ZM4.69531 7.2656L0 11.9609V13.9805V16H2.00685H4.0137L8.71431 11.2994C11.2996 8.71403 13.4097 6.59333 13.4032 6.5867C13.3349 6.51606 9.39556 2.57027 9.39347 2.57027C9.39189 2.57027 7.27773 4.68317 4.69531 7.2656ZM9.60863 4.57879C9.72116 4.69132 9.75253 4.78467 9.7113 4.88423C9.69525 4.92297 8.53825 6.09849 7.1402 7.49648C4.31813 10.3184 4.51784 10.1414 4.31064 10.0043C4.17404 9.91391 4.11556 9.78453 4.15498 9.66005C4.17876 9.585 4.69923 9.05002 6.67313 7.0718C8.04162 5.70031 9.19572 4.55646 9.23777 4.52994C9.27982 4.50341 9.35856 4.48167 9.41279 4.48162C9.49306 4.48154 9.52938 4.49956 9.60863 4.57879ZM4.02637 11.9863L5.0837 13.0439L4.28125 13.8466L3.4788 14.6494H3.07729H2.67577V13.9873V13.3251L2.00683 13.3183L1.33788 13.3115L1.3308 12.9301L1.32371 12.5487L2.13338 11.7388C2.5787 11.2933 2.9489 10.9288 2.95606 10.9288C2.9632 10.9288 3.44486 11.4047 4.02637 11.9863Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
